
import { PremiumPaywallSignModes, AuthStepsEnum } from "../../../../../global/paywall/paywallInterfaces";
import { getAuthHookFactory } from "../../../../../global/paywall/useAuth";
import { PremiumCalcalistPaywallDesktopSigninEmail } from "./signin/premiumCalcalistPaywallDesktopSigninEmail";
import { PremiumCalcalistPaywallDesktopSigninPassword } from "./signin/premiumCalcalistPaywallDesktopSigninPassword";
 


interface PremiumCalcalistPaywallDesktopSigninProps {
  emailOrPhone: string
  password: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (mode: PremiumPaywallSignModes) => void
  setIsRedirecting: (isRedirect: boolean) => void

}

export const PremiumCalcalistPaywallDesktopSignin = (props: PremiumCalcalistPaywallDesktopSigninProps) => {
  const { emailOrPhone, setEmailOrPhone, password, setPassword, setMode, agreesTerms, setAgreesTerms, setIsRedirecting } = props
  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    resetAuth,
    setAuthError,
    setSignInType,
    signInType,
  } = getAuthHookFactory("login")();


  const sendMail = () => {
    sendEmailOrPhoneForLogin(emailOrPhone, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onReset = () => {
    resetAuth()
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }

  switch (step) {
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumCalcalistPaywallDesktopSigninEmail
          emailOrPhone={emailOrPhone}
          setEmailOrPhone={setEmailOrPhone}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          setAuthError={setAuthError}
          setSignInType={setSignInType}
          signInType={signInType}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumCalcalistPaywallDesktopSigninPassword
          emailOrPhone={emailOrPhone}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          onBack={onReset}
          sendMail={sendMail}
          authError={authError}
          setEmailOrPhone={setEmailOrPhone}
              signInType={signInType}
        />
      )

    case AuthStepsEnum.CONFIRM_TERMS:
      // if its sign in, we dont need to confirm terms
      onThirdPartyLogin(false)
      return null

    case AuthStepsEnum.FINISH:
      setIsRedirecting(true)
      return null;

    default:
      return null
  }
};
